import { Skeleton } from 'antd';
import clsx from 'clsx';

interface WidgetSkeletonProps {
  showBorder?: boolean;
  showTitleDivider?: boolean;
  className?: string;
}

export function WidgetSkeleton({
  showBorder,
  showTitleDivider,
  className,
}: Readonly<WidgetSkeletonProps>) {
  return (
    <div
      className={`bg-wl-background px-6 py-8 sm:px-10 sm:py-12 rounded-xl shadow-sm relative ${className}`}
    >
      <div
        className={clsx('space-y-3 space-x-2', {
          'border-l-2 pl-4': showBorder,
          'pb-4 border-b mb-6': showTitleDivider,
        })}
      >
        {/* Title placeholders */}
        <Skeleton.Input
          active
          size='small'
          className='w-16 h-4 rounded-lg dark:bg-gray-200'
        />
        <Skeleton.Input
          active
          size='small'
          className='w-16 h-4 rounded-lg dark:bg-gray-200'
        />
      </div>

      {/* Middle placeholder */}
      <div className='mt-[18px]'>
        <Skeleton.Input
          active
          size='small'
          className='w-16 h-4 rounded-lg dark:bg-gray-200'
        />
      </div>

      {/* Bottom placeholder */}
      <div className='mt-8'>
        <Skeleton.Input
          active
          size='default'
          className='w-40 h-4 rounded-lg dark:bg-gray-200'
        />
      </div>
    </div>
  );
}
